/**
 * TanStack Query hooks for `post-affiliate-pro-integration-via-api`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	postAffiliateProIntegrationViaApiQueryKeys,
	type CreatePostAffiliateProIntegrationViaApiBody,
	type ListPostAffiliateProIntegrationViaApiResponse,
	type PostAffiliateProIntegrationViaApiRow,
} from "./api";

export function usePostAffiliateProIntegrationViaApiList(): UseQueryResult<ListPostAffiliateProIntegrationViaApiResponse, Error> {
	return useQuery({
		queryKey: postAffiliateProIntegrationViaApiQueryKeys.list(),
		queryFn: list,
	});
}

export function usePostAffiliateProIntegrationViaApiCreate(): UseMutationResult<PostAffiliateProIntegrationViaApiRow, Error, CreatePostAffiliateProIntegrationViaApiBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: postAffiliateProIntegrationViaApiQueryKeys.all });
		},
	});
}

export function usePostAffiliateProIntegrationViaApiDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: postAffiliateProIntegrationViaApiQueryKeys.all });
		},
	});
}
